import React from 'react'
import { StyledSvgG } from './Icon.styled'

const IconBack = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fillRule="evenodd">
        <StyledSvgG>
          <g>
            <g>
              <g>
                <path
                  d="M1 14c-.256 0-.512-.098-.707-.293-.39-.39-.39-1.023 0-1.414L5.586 7 .293 1.707c-.39-.39-.39-1.023 0-1.414.391-.39 1.023-.39 1.414 0l6 6c.391.391.391 1.023 0 1.414l-6 6c-.195.195-.45.293-.707.293"
                  transform="translate(-16 -13) translate(4 1) translate(12 12) matrix(-1 0 0 1 8 5)"
                />
              </g>
            </g>
          </g>
        </StyledSvgG>
      </g>
    </svg>
  )
}

export default IconBack
